import { Box, IconButton, useTheme } from '@mui/material';
import Hamburger from 'hamburger-react';
import { forwardRef } from 'react';

import ImageWrapper from '../ImageWrapper';
import { headerStyles } from './Header.styles';
import WelcomeBackBanner from './WelcomeBackBanner';

import { TAGLink } from '@shared-components-web';
import { Maybe } from '@shared-components-web/types';
import { AnalyticsContext } from '@src/lib/__generated/contentful/sdk';

export default forwardRef<
	HTMLDivElement,
	{
		appData: any;
		logoHref: string;
		isSmallScreen: boolean;
		isNavMenuOpen: boolean;
		setIsNavMenuOpen: (isOpen: boolean) => void;
		logoLinkAnalyticsContext?: Maybe<AnalyticsContext>;
	}
>(({ appData, logoHref, isSmallScreen, isNavMenuOpen, setIsNavMenuOpen, logoLinkAnalyticsContext }, ref) => {
	const logoUrl = appData?.logo?.url || '';

	const theme = useTheme();

	// only allow menu on user portal pages
	const showMenu = !!globalThis.location.pathname.includes('/user-portal') && isSmallScreen;
	const headerSuffix = isSmallScreen ? 'mobile' : 'desktop';
	const headerId = `section_header_${headerSuffix}`;

	return (
		<Box component="header" id={headerId} data-test-id={headerId} sx={headerStyles} ref={ref}>
			<TAGLink
				href={logoHref}
				analyticsContext={logoLinkAnalyticsContext}
				linkSx={{
					display: 'flex',
					flexFlow: 'row nowrap',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<ImageWrapper src={logoUrl} width="116px" height="auto" data-test-id="img_logo" alt="brand logo" />
			</TAGLink>
			<WelcomeBackBanner />
			{showMenu && (
				<IconButton sx={{ p: 0 }} data-test-id="menu-button" tabIndex={-1} size="large">
					<Hamburger
						size={24}
						toggled={isNavMenuOpen}
						toggle={() => setIsNavMenuOpen(!isNavMenuOpen)}
						color={theme.palette.text.interactive}
						label="open menu"
					/>
				</IconButton>
			)}
		</Box>
	);
});
